import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { getAllActivities } from "../auth/getAllActivities";
import { allActivitiesState } from "../lib/recoil";
import { getStationData } from "../lib/utilities";

export const useStationData = (stNr, update) => {
  const [isLoading, setIsLoading] = useState(true);
  const [globalAllActivities, setGlobalAllActivities] = useRecoilState(allActivitiesState);
  const [specificStationData, setSpecificStationData] = useState();

  useEffect(() => {
    const fetchAllActivities = async () => {
      if (globalAllActivities.length === 0 || update) {
        const allActivities = await getAllActivities();
        setGlobalAllActivities(allActivities);
        const stationData = getStationData(allActivities, stNr);
        setSpecificStationData(stationData);
      } else {
        const stationData = getStationData(globalAllActivities, stNr);
        setSpecificStationData(stationData);
      }
    };
    fetchAllActivities();
    setIsLoading(false);
    // eslint-disable-next-line
  }, []);

  return [specificStationData, isLoading];
};
